export default "__VITE_ASSET__C3uyXP29__"